(function () {
  const ACTIVE_WIDTH_PX = 320;
  const INACTIVE_WIDTH_PX = 220;
  const MOBILE_WIDTH_VW = 78;
  const GAP = 16;
  const VISIBLE_SLOTS = 9;
  const CENTER_SLOT = Math.floor(VISIBLE_SLOTS / 2);
  const TRANSITION = '0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)';

  function initVideoCarousel(sectionId) {
    const section = document.getElementById('video-carousel-' + sectionId);
    if (!section) return;

    const track = section.querySelector('.video-carousel__track');
    const dots = Array.from(section.querySelectorAll('.video-carousel__dot'));

    const sourceSlides = Array.from(track.querySelectorAll('.video-carousel__slide'));
    const totalReal = sourceSlides.length;
    if (totalReal === 0) return;

    track.innerHTML = '';

    let activeAbsIndex = 0;
    let currentTranslate = 0;
    let isDragging = false;
    let startX = 0;
    let dragDelta = 0;
    let pendingRecycle = null;
    let isAnimating = false;

    // ---- Build initial slots ----
    const slots = [];
    for (let s = 0; s < VISIBLE_SLOTS; s++) {
      const absIndex = s - CENTER_SLOT;
      const realIndex = ((absIndex % totalReal) + totalReal) % totalReal;
      const slide = sourceSlides[realIndex].cloneNode(true);
      slide.dataset.absIndex = absIndex;
      slide.classList.remove('is-active');
      track.appendChild(slide);
      slots.push(slide);
    }

    // ---- Helpers ----
    function isMobile() {
      return window.innerWidth < 768;
    }

    function getActiveWidth() {
      return isMobile() ? window.innerWidth * (MOBILE_WIDTH_VW / 100) : ACTIVE_WIDTH_PX;
    }

    function getInactiveWidth() {
      return isMobile() ? window.innerWidth * (MOBILE_WIDTH_VW / 100) : INACTIVE_WIDTH_PX;
    }

    function getActiveSlotIndex() {
      return slots.findIndex(s => parseInt(s.dataset.absIndex) === activeAbsIndex);
    }

    function calcTranslate(absIndex) {
      const containerWidth = track.parentElement.offsetWidth;
      const activeW = getActiveWidth();
      const inactiveW = getInactiveWidth();
      const activeSlotIdx = slots.findIndex(s => parseInt(s.dataset.absIndex) === absIndex);
      const offsetToActive = activeSlotIdx * (inactiveW + GAP);
      return -(offsetToActive - (containerWidth / 2 - activeW / 2));
    }

    function applyActiveClasses() {
      slots.forEach((slot) => slot.classList.remove('is-active'));
      const activeSlotIdx = getActiveSlotIndex();
      if (activeSlotIdx !== -1) slots[activeSlotIdx].classList.add('is-active');

      const realIndex = ((activeAbsIndex % totalReal) + totalReal) % totalReal;
      dots.forEach((d) => d.classList.remove('is-active'));
      if (dots[realIndex]) dots[realIndex].classList.add('is-active');
    }

    // Reset a video back to its default non-playing state
    function resetVideo(slot) {
      const video = slot.querySelector('.video-carousel__video');
      const btn = slot.querySelector('.video-carousel__play-btn');
      if (video && !video.paused) {
        video.pause();
        video.currentTime = 0;
      }
      if (video) {
        video.muted = true;
        video.controls = false;
      }
      if (btn) btn.classList.remove('is-hidden');
    }

    // ---- Recycle one slot after animation completes ----
    function recycleSlot(direction) {
      if (direction > 0) {
        const recycled = slots.shift();
        const newAbsIndex = parseInt(slots[slots.length - 1].dataset.absIndex) + 1;
        const realIndex = ((newAbsIndex % totalReal) + totalReal) % totalReal;
        const newContent = sourceSlides[realIndex].cloneNode(true);
        recycled.innerHTML = newContent.innerHTML;
        recycled.className = newContent.className;
        recycled.dataset.absIndex = newAbsIndex;
        recycled.classList.remove('is-active');
        track.appendChild(recycled);
        slots.push(recycled);
      } else {
        const recycled = slots.pop();
        const newAbsIndex = parseInt(slots[0].dataset.absIndex) - 1;
        const realIndex = ((newAbsIndex % totalReal) + totalReal) % totalReal;
        const newContent = sourceSlides[realIndex].cloneNode(true);
        recycled.innerHTML = newContent.innerHTML;
        recycled.className = newContent.className;
        recycled.dataset.absIndex = newAbsIndex;
        recycled.classList.remove('is-active');
        track.prepend(recycled);
        slots.unshift(recycled);
      }

      const newTranslate = calcTranslate(activeAbsIndex);
      track.style.transition = 'none';
      track.style.transform = `translateX(${newTranslate}px)`;
      track.getBoundingClientRect();
      currentTranslate = newTranslate;
      requestAnimationFrame(() => {
        track.style.transition = TRANSITION;
      });

      wirePlayButtons();
    }

    // ---- transitionend: fire pending recycle ----
    track.addEventListener('transitionend', (e) => {
      if (e.target !== track || e.propertyName !== 'transform') return;
      isAnimating = false;

      if (pendingRecycle !== null) {
        recycleSlot(pendingRecycle);
        pendingRecycle = null;
      }
    });

    // ---- goTo ----
    function goTo(absIndex, animate = true) {
      const direction = absIndex >= activeAbsIndex ? 1 : -1;

      // Reset all videos
      slots.forEach((slot) => resetVideo(slot));

      activeAbsIndex = absIndex;
      applyActiveClasses();
      currentTranslate = calcTranslate(absIndex);

      if (!animate) {
        track.style.transition = 'none';
        track.style.transform = `translateX(${currentTranslate}px)`;
        track.getBoundingClientRect();
        requestAnimationFrame(() => { track.style.transition = TRANSITION; });
        isAnimating = false;
        pendingRecycle = null;
      } else {
        track.style.transition = TRANSITION;
        track.style.transform = `translateX(${currentTranslate}px)`;
        isAnimating = true;
        pendingRecycle = direction;
      }
    }

    // ---- Play button wiring ----
    function wirePlayButtons() {
      slots.forEach((slot) => {
        const btn = slot.querySelector('.video-carousel__play-btn');
        const video = slot.querySelector('.video-carousel__video');
        if (!btn || !video) return;

        const newBtn = btn.cloneNode(true);
        btn.replaceWith(newBtn);

        newBtn.addEventListener('click', () => {
          const slotAbsIndex = parseInt(slot.dataset.absIndex);

          // If not the active slide, just navigate to it
          if (slotAbsIndex !== activeAbsIndex) {
            goTo(slotAbsIndex);
            return;
          }

          // Ensure src is set (handles recycled slots where src may have been cleared)
          if (!video.src && video.dataset.src) {
            video.src = video.dataset.src;
          }

          // Unmute and show native controls for playback
          video.muted = false;
          video.controls = true;
          newBtn.classList.add('is-hidden');

          video.play().catch(() => {
            // Autoplay blocked — fall back to muted play
            video.muted = true;
            video.play().catch(() => {});
          });
        });

        video.addEventListener('ended', () => {
          video.muted = true;
          video.controls = false;
          video.currentTime = 0;
          newBtn.classList.remove('is-hidden');
        });

        video.addEventListener('pause', () => {
          video.controls = false;
          newBtn.classList.remove('is-hidden');
        });
      });
    }

    // ---- Dots ----
    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const realIndex = ((activeAbsIndex % totalReal) + totalReal) % totalReal;
        const diff = i - realIndex;
        goTo(activeAbsIndex + diff);
      });
    });

    // ---- Drag / Swipe ----
    track.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.clientX;
      dragDelta = 0;
      track.style.transition = 'none';
      track.classList.add('is-dragging');
    });

    track.addEventListener('touchstart', (e) => {
      isDragging = true;
      startX = e.touches[0].clientX;
      dragDelta = 0;
      track.style.transition = 'none';
    }, { passive: true });

    window.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      dragDelta = e.clientX - startX;
      track.style.transform = `translateX(${currentTranslate + dragDelta}px)`;
    });

    window.addEventListener('touchmove', (e) => {
      if (!isDragging) return;
      dragDelta = e.touches[0].clientX - startX;
      track.style.transform = `translateX(${currentTranslate + dragDelta}px)`;
    }, { passive: true });

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');

      const threshold = 60;
      if (dragDelta < -threshold) {
        goTo(activeAbsIndex + 1);
      } else if (dragDelta > threshold) {
        goTo(activeAbsIndex - 1);
      } else {
        track.style.transition = TRANSITION;
        track.style.transform = `translateX(${currentTranslate}px)`;
      }
      dragDelta = 0;
    }

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('touchend', endDrag);

    // ---- Init ----
    goTo(0, false);
    wirePlayButtons();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        currentTranslate = calcTranslate(activeAbsIndex);
        track.style.transform = `translateX(${currentTranslate}px)`;
      }, 100);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[id^="video-carousel-"]').forEach((el) => {
      const id = el.id.replace('video-carousel-', '');
      initVideoCarousel(id);
    });
  });

  document.addEventListener('shopify:section:load', (e) => {
    initVideoCarousel(e.detail.sectionId);
  });
})();
